/* eslint-disable */
/**
 * AUTO-GENERATED FILE — DO NOT EDIT.
 *
 * Generated by: scripts/generate-embedded-react-exports.mjs
 * Source: react-dom@18.3.1 (ESM entry)
 * Generated at: 2026-01-17T18:59:01.271Z
 */

export const EMBEDDED_REACT_DOM_18_VERSION = "18.3.1" as const;

export const EMBEDDED_REACT_DOM_18_NAMED_EXPORTS = [
  "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED",
  "createPortal",
  "createRoot",
  "findDOMNode",
  "flushSync",
  "hydrate",
  "hydrateRoot",
  "render",
  "unmountComponentAtNode",
  "unstable_batchedUpdates",
  "unstable_renderSubtreeIntoContainer",
  "version"
] as const;
